module.exports = __webpack_public_path__ + "static/media/default-vehicle.8c23db0a.svg";